import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const Callback = () => {
  const navigate = useNavigate();
  // const { fetchUser } = useAuth();

  const handleLogin = () => {
    localStorage.removeItem("access_token");
    navigate("/login", { replace: true });
  };
  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const ssoToken = urlParams.get("sso_token");

      if (ssoToken) {
        localStorage.setItem("access_token", ssoToken);
         navigate("/");
      } else {
        handleLogin();
      }
    };

    handleCallback();
  }, [navigate]);

  return null;
};

export default Callback;
